import { Headers } from '@egw/components'
import { SavingsDetailsPage } from '@egw/features-account'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const SavingsAccountDetailsPage: FC = () => {
  const { t } = useTranslation()
  const { alias } = useParams<{ alias: string }>()

  return alias ? (
    <Layout>
      <Headers title={t('pages.savings.title')} />
      <SavingsDetailsPage alias={parseInt(alias)} />
    </Layout>
  ) : null
}
